export const environment = {
    production: false,
    hmr       : false,

    // Micro Frontend Shell: URL do manifesto que descreve os MFEs disponíveis.
    // Ver docs/mfe-architecture.md.
    mfeManifestUrl: 'assets/mfe/mfe-manifest.hom.json',

    brasilApi: 'https://brasilapi.com.br/api', // API COM VARIAS FUNCIONALIDADES DE RETORNO DE DADOS BRASILEIROS **https://brasilapi.com.br/**

    apiUrl: 'https://homologacao.a2wplataforma.com.br:7081/api',// DFE   
    apiUrl2: 'https://homologacao.a2wplataforma.com.br:7082/api', // ACCOUNT
    apiPrevisaoSafra: 'https://homologacao.a2wplataforma.com.br:7086/api', // PREVISAO SAFRA
    baseUrl: 'https://homologacao.a2wplataforma.com.br:7083/api/v1', // ATIVIDADES
    apiurlDashBoardPainel: 'https://homologacao.a2wplataforma.com.br:7084/api', // DASHBOARD 
    apiUrlRDV: 'https://hml-module-rdv.a2w.app/api', // RDV
    apiContas: 'https://homologacao.a2wplataforma.com.br:7088/api',//CONTAS A RECEBER
    apiAdministration: 'https://homologacao.a2wplataforma.com.br:7089/api', //ADMINISTRATION 
    apiDfeDois: 'https://homologacao.a2wplataforma.com.br:7091/api', //DFE dois
    keyNewArq: 'V0E0NjR6aTFNNHgjcDZkOCUhQWsmNg==',
    integrationUser: 'https://hml-integration-accounts.a2w.app/api/accounts', //ROTA NEW ARQ INTEGRAÇÃO users
    integrationRdv: 'https://hml-integration-rdv.a2w.app/api/rdv/integration', //ROTA NEW ARQ INTEGRAÇÃO RDV
    integrationToken: 'Vk1WM0JwcVd1NmVWVVAzUDE2Nm5BVTBEVHN5SzIyNDV5OHRHdGZqRVpWVWwybWEyZG1wTEpQRHNaVW1obmxKTFMzQmxFdlBMb3V0N1V5UzN5MWJtMGdqZGRGZGZ5Mm5qb29hMWFqZ0FVV0hSRUd5MkVGNllubm52bDFDUVZDMFlFakJ0bWdTQ2w2MzZiYjIyMjVjMTg3',
    apiGoogleCalendar: 'https://hml-google-calendar.a2w.app/api',
    warehouseInfo: 'https://hml-warehouse.a2w.app/api', // ROTA IMPORTAR ESTOQUE
    apiFunilVendas: 'https://hml-funil-vendas.a2w.app/api', // ROTA FUNIL DE VENDAS
    apiCards: 'https://hml-cards.a2w.app/api', // ROTA CARDS
    apiExcel: 'https://hml-excel-integration.a2w.app/api', // UPLOAD DE EXCEL LISTA DE PREÇO
    apiCoberturaPositivacao: 'https://hml-cobertura-positivacao.a2w.app/api',
    apiSemaforos: 'https://hml-semaphores.a2w.app', // semaforos
    apiPacotesTecnologicos: 'https://hml-pgd.a2w.app/api', // pacotes tecnologicos
    apiPlanejamentoAtividades: 'https://hml-planejamento-atividades.a2w.app/api', // Planejamento de Atividades
    apiIntegracaoManual: 'https://workerb-one.a2w.app/api', //Integração Manual de filtros de lista de preço
    apiOfertaEstruturada: 'https://hml-oferta-estruturada.a2w.app/api', // Oferta Estruturada
    apiAprovacaoPedidos: 'https://hml-aprovacao-pedidos.a2w.app/api', // Aprovacões de Pedidos 
    apiPipeline: 'https://hml-pipeline.a2w.app/api', //Pipeline
    apiProdutos: 'https://hml-module-produto.a2w.app/api', //Nova Api de produtos
    apiMetas: 'https://hml-module-metas.a2w.app',
    apiSincronizacaoRDV: 'https://hml-rdv-integration-service.a2w.app/api', // API DE SINCRONIZAÇÃO DO RDV
    apiListaPreco: 'https://hml-module-lista-preco.a2w.app/api', // Api de lista de preço
    apiParceiroNegocio: 'https://hml-module-parceiro-negocio.a2w.app/api', // Api de Parceiro Negocio
    apiRendimentoPay: 'https://hml-rendimento-pay.a2w.app/api', // A2W Card
    apiImportacaoNotasFiscais:'https://hml-sap-bone-invoice-search.a2w.app/api',
    apiMicrosoftSSO: 'https://hml-microsoft-sso.a2w.app', //Api EntraID
    apiComissao: 'https://hml-module-comissao.a2w.app/api',
    apiOutlook: 'https://hml-outlook-calendario.a2w.app', //API do Outlook
    apiImportacaoManualNotaFiscal: 'https://hml-integration-sapbone-orders.a2w.app/api', // API de importação manual de notas fiscais   
    apiLara: 'https://hml-zapi-integration-service.a2w.app/api', //API Lara
    apiWhatsAppMeta: 'https://hml-whatsapp-meta-onboarding.a2w.app/api', //API Whatsapp Meta
    apiDashBoard: 'https://hml-dashboard.a2w.app/api', // API DashBoard
    apiPedido: 'https://hml-module-pedido.a2w.app/api', // API Pedido
    apiCondPagto: 'https://hml-module-cond-pagto.a2w.app', //API CondPagto
    apiCasasDecimais: 'https://hml-module-casas-decimais.a2w.app/', //API Casas Decimais
    apiBackStage: 'https://hml-backstage.a2w.app/api/v1', //API BackStage

};
